import { useTranslation } from 'react-i18next';

import { LoginMessagingPageSm } from './LoginMessagingPage.sm';

import { ColumnsLayout } from '@components/templates/ColumnsLayout/ColumnsLayout';

import { useResponsive } from '@utils/hooks/useResponsive';
import { useServiceRedirect } from '@utils/hooks/useServiceRedirect';
import { useUserLogin } from '@utils/hooks/useUserLogin';

import { CheckStatusForm } from '@domains/auth/organisms/CheckStatusForm/CheckStatusForm';
import { LoginForm } from '@domains/auth/organisms/LoginForm/LoginForm';

import { LoginCard } from './LoginMessagingPage.styled';

export const LoginMessagingPage = () => {
    useServiceRedirect({ path: '/incidents/reports' });
    const { t } = useTranslation();

    const isSm = useResponsive('sm');

    const { login, sessionProcessing } = useUserLogin();

    if (isSm) return <LoginMessagingPageSm />;

    return (
        <ColumnsLayout
            breadcrumb={t('SEE_MY_CASES')}
            contentPadding={{
                bottom: 40,
                top: 16,
            }}
            title={t('SEE_MY_CASES')}
        >
            <LoginCard testId="ZVYM9zL">
                <LoginCard.TitleTertiary>
                    {t('ALREADY_HAVE_AN_ACCOUNT')}
                </LoginCard.TitleTertiary>
                <LoginCard.Description>
                    {t('SIGN_IN_TO_RETRIEVE')}
                </LoginCard.Description>
                <LoginForm
                    handleLoginSubmit={login}
                    loading={sessionProcessing}
                />
            </LoginCard>
            <LoginCard testId="nhgKicm">
                <LoginCard.TitleTertiary>
                    {t('DO_NOT_HAVE_ACCOUNT')}
                </LoginCard.TitleTertiary>
                <LoginCard.Description>
                    {t('RETRIEVE_MY_REPORTS')}
                </LoginCard.Description>
                <CheckStatusForm />
            </LoginCard>
        </ColumnsLayout>
    );
};
